import { CatalogModel } from 'types/models/catalog'

export const catalogsInAscOrder = (catalog: CatalogModel, other: CatalogModel) =>
  catalog.order - other.order
